var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.852 161.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 -80.852 468.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m142.12-49.616v301.23c0 35.772 15.06 53.634 45.222 53.634h7.662v20.706h-160.94v-20.706h10.722c30.162 0 45.222-17.868 45.222-53.634v-197.75c0-36.27-12.786-54.42-38.334-54.42h-16.092v-20.676h6.138c31.158 0 59.508-9.45 85.08-28.374l15.324-0.0067zm244.5 214.63c-28.104 26.574-56.19 39.858-84.294 39.858-30.654 0-55.452-12.534-74.358-37.578-16.872-21.954-25.296-48.78-25.296-80.46 0-34.248 9.948-64.902 29.874-91.974 22.476-29.124 50.34-43.686 83.55-43.686 40.368 0 72.294 17.37 95.802 52.116 21.96 31.182 32.964 67.704 32.964 109.59 0 60.318-19.8 111.02-59.394 152.15-39.612 41.13-89.286 61.962-149.08 62.46v-19.926c18.396-1.026 32.964-3.09 43.686-6.138 60.828-18.408 96.312-63.876 106.54-136.42zm3.846-37.584c0.49202-8.136 0.77399-15.81 0.77399-22.98 0-29.628-5.112-56.7-15.342-81.24-13.794-32.184-33.21-48.282-58.266-48.282-21.948 0-38.076 10.98-48.27 32.964-8.706 17.874-13.044 38.832-13.044 62.844 0 26.04 4.092 48.558 12.258 67.422 10.734 25.044 27.612 37.584 50.592 37.584 27.6 0 51.36-16.092 71.298-48.312z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana19);
export default __webpack_public_path__ + "static/media/mana19.cfdcbc6772146b9172be15c171f793b5.svg";
export { ForwardRef as ReactComponent };